






























import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import AsiRadioGroup from "../common/AsiRadioGroup";
import AsiTextField from "../common/AsiTextField";
import BillCreate from "@/models/bill/BillCreate";
import {AxiosError} from "axios";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import {enumToSelectItems} from "@/helpers/functions_asi";
import {BillCreateOption} from "@/helpers/constants";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {
		AsiSelectSimple,
		AsiDialogFormLayout,
		AsiRadioGroup,
		AsiTextField,
		AsiDatePicker,
		CompanyAutocompleteInput
	}
})
export default class BillCreateDialog extends AsiDialogForm {

	@Prop({type: Object, default: null})
	public company!: CompanySimple | null;

	@Prop({type: Boolean, default: false})
	public noRedirectOnSave!: boolean;

	protected model: BillCreate = new BillCreate();
	private billCreateOption: BillCreateOption = BillCreateOption.addNoReports;
	private billCreateOptions = enumToSelectItems(BillCreateOption, true);

	private get dateRangeEnabled(): boolean {
		return this.billCreateOption === BillCreateOption.addReportsInRange;
	}

	private get reportRange(): string[] | null {
		if (this.model.addReportsRangeFrom === null && this.model.addReportsRangeTo === null) {
			return [];
		} else if (this.model.addReportsRangeFrom !== null && this.model.addReportsRangeTo !== null) {
			return [this.model.addReportsRangeFrom, this.model.addReportsRangeTo];
		} else {
			if (this.model.addReportsRangeFrom !== null) {
				return [this.model.addReportsRangeFrom];
			} else if (this.model.addReportsRangeTo !== null) {
				return [this.model.addReportsRangeTo];
			} else {
				return [];
			}
		}
	}

	private set reportRange(value: string[] | null) {
		if (value === null || value.length === 0) {
			this.model.addReportsRangeFrom = null;
			this.model.addReportsRangeTo = null;
			return;
		}

		if (value.length === 1) {
			this.model.addReportsRangeFrom = value[0];
			this.model.addReportsRangeTo = null;
		} else {
			this.model.addReportsRangeFrom = value[0];
			this.model.addReportsRangeTo = value[1];
		}
	}

	public created(): void {
		if (this.company !== null) {
			this.model.companyId = this.company.id;
		}
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.billCreateOption = BillCreateOption.addNoReports;
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		return event;
	}

	@Watch('company')
	private onCompanyChanged(): void {
		this.model.companyId = this.company !== null ? this.company.id : null;
	}

	private billCreateOptionChanged(): void {
		switch (this.billCreateOption) {
			case BillCreateOption.addReportsInRange:
				this.model.addReports = true;
				break;
			case BillCreateOption.addAllReports:
				this.model.addReports = true;
				this.model.addReportsRangeFrom = null;
				this.model.addReportsRangeTo = null;
				break;
			case BillCreateOption.addNoReports:
				this.model.addReports = false;
				this.model.addReportsRangeFrom = null;
				this.model.addReportsRangeTo = null;
				break;
		}
	}

	private dateRangeChanged(value: string[]) {
		if (value.length === 0) {
			this.model.addReportsRangeFrom = null;
			this.model.addReportsRangeTo = null;
		} else {
			this.model.addReportsRangeFrom = value[0];
			this.model.addReportsRangeTo = value[1] ?? null;
		}
	}

	private requestSave(event: Event): void {
		this.loading = true;
		this.$billService.create(this.model)
			.then(res => {
				if (!this.noRedirectOnSave) {
					this.$router.push({name: 'Bill', params: {id: res.id}});
				}
				this.save(event);
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
